
import Loading from 'vux/src/components/loading/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import { mapState } from 'vuex'

export default {
name: 'app',
components: {
Loading,
Spinner
},
computed: {
...mapState({
isLoading: state => state.isLoading
})
}
}



// WEBPACK FOOTER //
// ./src/App.vue